'use strict';

// @flow

var TokenLogin = require('./functions/TokenLogin');
var SendSMSCode = require('./functions/SendSMSCode');
var CreateTeam = require('./functions/CreateTeam');
var InviteTeamMembers = require('./functions/InviteTeamMembers');
var CreateRoom = require('./functions/CreateRoom');
var AcceptTeamInvite = require('./functions/AcceptTeamInvite');
var AddUsersToRoom = require('./functions/AddUsersToRoom');
var CreateTeamInvite = require('./functions/CreateTeamInvite');
var RemoveUsersFromRoom = require('./functions/RemoveUsersFromRoom');
var RemoveUsersFromTeam = require('./functions/RemoveUsersFromTeam');

var FUNCTIONS = {
  'tokenLogin': TokenLogin,
  'sendSMSCode': SendSMSCode,
  'createTeam': CreateTeam,
  'inviteTeamMembers': InviteTeamMembers,
  'createRoom': CreateRoom,
  'acceptTeamInvite': AcceptTeamInvite,
  'addUsersToRoom': AddUsersToRoom,
  'createTeamInvite': CreateTeamInvite,
  'removeUsersFromRoom': RemoveUsersFromRoom,
  'removeUsersFromTeam': RemoveUsersFromTeam
};

var LambdaUtils = {
  getFunctionInfo: function getFunctionInfo(body) {
    console.log('getFunctionInfo');

    if (!body) {
      console.log("ERROR from getFunctionInfo: undefined body");
      return false;
    }

    var endPoint = body.endPoint;
    if (!endPoint) {
      console.log("ERROR from getFunctionInfo: undefined endPoint");
      return false;
    }

    var functionInfo = FUNCTIONS[endPoint];
    if (!functionInfo) {
      console.log('ERROR from getFunctionInfo: unrecognized endPoint ' + endPoint);
      return false;
    }

    console.log('getFunctionInfo returns: ', functionInfo);
    return functionInfo;
  },

  isValidSchema: function isValidSchema(ajv, schema, body, callback) {
    console.log('isValidSchema');

    if (!schema) {
      console.log("ERROR from isValidSchema: undefined schema");
      callback('No Schema to validate');
      return false;
    }

    if (schema == 'NOT_NEEDED') {
      console.log('NOT_NEEDED');
      return true;
    }

    if (!body) {
      console.log("ERROR from isValidSchema: undefined body");
      callback('undefined body');
      return false;
    }

    console.log('ajv: ', ajv !== undefined);
    console.log('schema: ', schema);
    var validate = ajv.compile(schema);

    console.log('isValidSchema validate: ', validate);
    if (!body || !validate(body)) {
      var errorsText = ajv.errorsText(validate.errors);
      console.log("ERROR From isValidSchema: " + errorsText);
      callback(errorsText);
      return false;
    }

    console.log('isValidSchema returns true');
    return true;
  },

  initFirebase: function initFirebase(fbAdmin, context, event) {
    // Get stage
    var stageVars = event['stage-variables'];
    var stage = stageVars && stageVars.stage === 'prod' ? 'prod' : 'dev';
    console.log('Stage: ', stage);

    context.callbackWaitsForEmptyEventLoop = false; //<---Important

    // In lambda, Avoid double initialization. Try to find a previous app
    // initialized with same database
    console.log('Number of firebaseApp: ' + fbAdmin.apps.length);
    for (var i = 0; i < fbAdmin.apps.length; i++) {
      if (fbAdmin.apps[i].name === stage) {
        console.log('Found an initialized firebase');
        return fbAdmin.apps[i];
      }
    }

    // Connect with dev or prod firebase
    var suffix = stage === 'prod' ? '' : '-dev';
    var accountKeyPath = 'firebaseAccountKey' + suffix + '.json';
    var databaseURL = 'https://fibo-collab' + suffix + '.firebaseio.com/';

    // Initialize a new Firebase App
    console.log('Initialize firebase from ' + accountKeyPath);
    return fbAdmin.initializeApp({
      credential: fbAdmin.credential.cert(accountKeyPath),
      databaseURL: databaseURL
    }, stage);
  },

  saveToFirebase: function saveToFirebase(dbRef, updates, callback, params) {
    dbRef.update(updates).then(function () {
      console.log('Firebase DONE');
      var successParams = { success: true };
      if (params) {
        Object.assign(successParams, params);
      }
      callback(null, successParams);
    }).catch(function (error) {
      console.log('ERROR: ' + JSON.stringify(error, null, 2));
      callback(error);
    });
  }
};

module.exports = LambdaUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/LambdaUtils.js
// module id = 1027
// module chunks = 0